import React from 'react';
import TemplateForm from './TemplateForm';
import { addTemplate } from '../../api';

export default class extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.appBar = {
      title: 'NEW_TEMPLATE',
      navigateBack: true,
    };
  }

  render() {
    return (
      <TemplateForm
        name="addTemplate"
        appBar={this.appBar}
        request={addTemplate}
        confirmExit
      />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Template/TemplateAddition.js
 **/